import React from 'react';
import logo from '../../images/logo2.png';
import './style.css';

function App() {
  return <div className="App">Not Found</div>;
}

export default App;
